import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../prototype/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: 'The Tutor Index - Find expert, independent tutors for Maths, English, 11+ and more.' },
    component: Home
  },
  {
    path: '/:id([0-9]{5,6})-:stub(.*)/pay',
    name: 'PayTutor',
    // Meta details set in Article.vue
    component: () => import('../prototype/TutorPayMe.vue')
  },
  {
    path: '/:id([0-9]{5,6})-:stub(.*)/payment-cancelled',
    name: 'PayTutorCancelled',
    meta: { title: 'Payment Cancelled | The Tutor Index' },
    component: () => import('../prototype/TutorPayMe-Cancelled.vue')
  },
  {
    path: '/:id([0-9]{5,6})-:stub(.*)/payment-complete',
    name: 'PayTutorSuccess',
    meta: { title: 'Payment Complete | The Tutor Index' },
    component: () => import('../prototype/TutorPayMe-Success.vue')
  },
  {
    path: '/:id([0-9]{5,6})-:stub(.*)/pay-disabled',
    name: 'PayTutorDisabled',
    meta: { title: 'Payment Disabled | The Tutor Index' },
    component: () => import('../prototype/TutorPayMe-Disabled.vue')
  },
  {
    path: '/:id([0-9]{5,6})-:stub(.*)',
    name: 'Tutor',
    // Meta details set in Article.vue
    component: () => import('../prototype/Tutor.vue')
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    meta: { title: 'Sign up to The Tutor Index' },
    component: () => import(/* webpackChunkName: "signup" */ '../prototype/SignUp.vue')
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    meta: { title: 'Sign in to The Tutor Index' },
    component: () => import(/* webpackChunkName: "signin" */ '../prototype/SignIn.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: { title: 'Forgotten your password?' },
    component: () => import('../prototype/ForgotPassword.vue')
  },
  {
    path: '/reset-password/:userId',
    name: 'ResetPassword',
    props: true,
    meta: { title: 'Reset your password' },
    component: () => import('../prototype/ResetPassword.vue')
  },
  {
    path: '/articles',
    name: 'Articles',
    meta: { title: 'News, Announcements, and Help Articles' },
    component: () => import(/* webpackChunkName: "articles" */ '../prototype/Articles.vue')
  },
  {
    path: '/articles/:url',
    name: 'Article',
    // Meta details set in Article.vue
    component: () => import(/* webpackChunkName: "article" */ '../prototype/Article.vue')
  },
  {
    path: '/find-a-tutor',
    name: 'FindATutor',
    meta: { title: 'Find a Tutor' },
    component: () => import(/* webpackChunkName: "findatutor" */ '../views/FindATutor/Layout.vue'),
    children: [
      {
        name: 'FindATutor-Initial',
        path: '',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Initial.vue'),
      },
      {
        name: 'FindATutor-Level',
        path: 'level',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Level.vue'),
      },
      {
        name: 'FindATutor-Subject',
        path: 'subject',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Subject.vue'),
      },
      {
        name: 'FindATutor-Location',
        path: 'location',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Location.vue'),
      },
      {
        name: 'FindATutor-Rate',
        path: 'rate',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Rate.vue'),
      },
      {
        name: 'FindATutor-Message',
        path: 'message',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/Message.vue'),
      },
      {
        name: 'FindATutor-PersonalInfo',
        path: 'info',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/PersonalInfo.vue'),
      },
      {
        name: 'FindATutor-ThankYou',
        path: 'thanks',
        meta: { title: 'Find a Tutor' },
        component: () => import('../views/FindATutor/ThankYou.vue'),
      }
    ],
  },
  {
    path: '/my-account',
    component: () => import(/* webpackChunkName: "edittutor" */ '../prototype/EditTutor.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'EditTutor',
        path: '',
        meta: { title: 'My Account | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Overview.vue')
      },
      {
        name: 'EditTutor-Profile',
        path: 'profile',
        meta: { title: 'Profile | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Profile.vue')
      },
      {
        path: 'security',
        meta: { title: 'Account | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Security.vue')
      },
      {
        path: 'subjects',
        meta: { title: 'Subjects | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Subjects.vue')
      },
      {
        name: 'EditTutor-Enquiries',
        path: 'enquiries',
        meta: { title: 'Enquiries | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Enquiries.vue')
      },
      {
        path: 'locations',
        meta: { title: 'Coverage Map | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Locations.vue')
      },
      {
        path: 'rate-card',
        meta: { title: 'Rate Card | The Tutor Index' },
        component: () => import('../prototype/EditTutor-RateCard.vue')
      },
      {
        path: 'qualifications',
        meta: { title: 'Qualifications | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Qualifications.vue')
      },
      {
        name: 'EditTutor-OnlinePayments',
        path: 'online-payments',
        meta: { title: 'Online Payments | The Tutor Index' },
        component: () => import('../prototype/EditTutor-ConfigureStripe.vue'),
      },
      {
        path: 'online-payments/refresh',
        component: () => import('../prototype/EditTutor-ConfigureStripe-Refresh.vue')
      },
      {
        name: 'EditTutor-DbsCheck',
        path: 'dbs-check',
        meta: { title: 'DBS Check | The Tutor Index' },
        component: () => import('../prototype/EditTutor-DbsCheck.vue')
      },
      {
        name: 'EditTutor-IdCheck',
        path: 'id-check',
        meta: { title: 'ID Check | The Tutor Index' },
        component: () => import('../prototype/EditTutor-IdCheck.vue')
      },
      {
        name: 'EditTutor-References',
        path: 'references',
        meta: { title: 'References | The Tutor Index' },
        component: () => import('../prototype/EditTutor-References.vue')
      },
      {
        name: 'EditTutor-KCSIE',
        path: 'kcsie',
        meta: { title: 'Keeping Children Safe in Education | The Tutor Index' },
        component: () => import('../prototype/EditTutor-KCSIE.vue')
      },
      {
        name: 'EditTutor-Subscription',
        path: 'subscription',
        meta: { title: 'Subscription | The Tutor Index' },
        component: () => import('../prototype/EditTutor-SubscriptionNew.vue')
      },
      {
        name: 'EditTutor-Testimonials',
        path: 'testimonials',
        meta: { title: 'Testimonials | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Testimonials.vue')
      },
      {
        name: 'EditTutor-Articles',
        path: 'articles',
        meta: { title: 'Articles | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Articles.vue')
      },
      {
        name: 'EditTutor-Interview',
        path: 'interview',
        meta: { title: 'Interview | The Tutor Index' },
        component: () => import('../prototype/EditTutor-Interview.vue')
      },
    ]
  },
  {
    path: '/job-board',
    name: 'JobBoard',
    meta: { title: 'Job Board | The Tutor Index' },
    component: () => import(/* webpackChunkName: "jobboard" */ '../prototype/JobBoard/JobBoard.vue')
  },
  {
    path: '/submit-reference/:id',
    name: 'SubmitReference',
    meta: { title: 'Submit Reference | The Tutor Index' },
    component: () => import(/* webpackChunkName: "submitreference" */ '../prototype/SubmitReference.vue')
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    meta: { title: 'About Us | The Tutor Index' },
    component: () => import(/* webpackChunkName: "about" */ '../prototype/AboutUs.vue')
  },
  {
    path: '/search',
    name: 'SearchResults',
    meta: { title: 'Find a Tutor | The Tutor Index' },
    component: () => import('../views/SearchResults.vue')
  },
  {
    path: '/terms-and-conditions',
    meta: { title: 'Terms & Conditions | The Tutor Index' },
    component: () => import(/* webpackChunkName: "termsAndConditions" */ '../prototype/TermsAndConditions.vue')
  },
  {
    path: '/privacy-policy',
    meta: { title: 'Privacy Policy | The Tutor Index' },
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../prototype/PrivacyPolicy.vue')
  },
  {
    path: '/safeguarding-policy',
    meta: { title: 'Safeguarding Policy | The Tutor Index' },
    component: () => import(/* webpackChunkName: "safeguardingPolicy" */ '../prototype/SafeguardingPolicy.vue')
  },
  {
    name: 'OnlinePaymentTerms',
    path: '/online-payments-terms-and-conditions',
    meta: { title: 'Online Payments Terms & Conditions | The Tutor Index' },
    component: () => import(/* webpackChunkName: "onlinepaymentstermsAndConditions" */ '../prototype/OnlinePaymentsTermsAndConditions.vue')
  },
  {
    path: '/hello-world',
    component: () => import('../components/HelloWorld.vue')
  },
  {
    name: 'BecomeATutor',
    path: '/become-a-tutor',
    meta: { title: 'Become a Tutor | The Tutor Index' },
    component: () => import('../prototype/BecomeATutor.vue')
  },
  {
    name: 'FindMeATutor',
    path: '/find-me-a-tutor',
    meta: { title: 'Find me a Tutor | The Tutor Index' },
    component: () => import('../prototype/FindMeATutor.vue')
  },
  {
    path: '/payment',
    component: () => import('../prototype/Payment.vue')
  },
  {
    path: '/recruitment-policy',
    meta: { title: 'Recruitment Policy | The Tutor Index' },
    component: () => import(/* webpackChunkName: "recruitmentPolicy" */ '../prototype/RecruitmentPolicy.vue')
  },

  // Marketing Reirects
  {
    path: '/qtpodcast22',
    redirect: () => ({ name: 'Home', query: { 'utm_source': 'qt-podcast-nov22' } })
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(from, to, savedPosition) {
    return savedPosition
      ? savedPosition
      : { x: 0, y: 0 };
    // https://router.vuejs.org/guide/advanced/scroll-behavior.html#scroll-behavior
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/sign-in',
        //query: { returnTo: to.fullPath }
      });
    }
    else {
      next();
    }
  }
  else {
    next();
  }
});

router.afterEach(to => {
  document.title = to.meta.title || 'The Tutor Index'
});

export default router
